import { vservice } from '@niknevis/vue-modules'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { PanelBillingInfoRoute } from '@/modules/billing-info/routes/panel-billing-info.route'
import { BillingInfoResourceModel } from '@/modules/billing-info/models/billing-info-resource'

@vservice()
export class PanelBillingInfoService {
  constructor(
    private readonly routes: PanelBillingInfoRoute
  ) {
  }

  updateBillingInfo(data: BillingInfoResourceModel) {
    return Inertia.put(
      this.routes.billingInfoUpdate(),
      data
    )
  }

}
